import nsic from '../images/nsic.jpg';
import jorim from '../images/jorim.jpg';
import innovik from '../images/innovik.jpeg';
import chaitanya from '../images/chaitanya.jpg';
import tirumala from '../images/tirumala.jpg';
import sairam from '../images/sairam.jpg';

export const Img = {
    nsic,jorim,innovik,chaitanya,tirumala,sairam
}